import React from 'react';
import SEO from "../components/seo"
import Contact from "../components/ContactForm"
import Layout from "../components/layout"

const ContactPage = () => {
    return (
        <Layout>
            <SEO
                title="İletişim | Telefon | Adres | Ayazsan"
                description="Konya'da yapı dekorasyon veya tadilat firması mı arıyorsunuz? Ayazsan inşaat ile buradan iletişime geçin"
            />
            <Contact />
        </Layout>
    );
};

export default ContactPage;